export default {
  // 数据上次更新时间戳(ms)
  updatedAt: 0,
  // 白名单列表
  pageList: [],
  // 是否游客模式
  visitor: false,
  // portal配置
  portalCode: ''
}
